import { IDeliveryForm } from "../../../../Types/MeetingPlanning/deliveryForm"
import { useFormikContext } from "formik"
import { useMoney } from "../../../Localization/useMoney"
import React, { memo, useMemo } from "react"
import { dinero } from "dinero.js"
import { toCurrency } from "../../../../Helpers/CurrencyHelper"
import { Grid } from "@material-ui/core"
import { LocalizedStrict } from "../../../Localization/Components/Localized"
import { FormikFloatingSubmitButton } from "../../../../Components/Form/Formik"

export const SubmitButton = () => {
    const { values, isValid } = useFormikContext<IDeliveryForm>()
    const moneyFactory = useMoney()
    const finalPrice = useMemo(() => moneyFactory.format(dinero({ amount: values?.price || 0, currency: toCurrency('DKK') })), [values?.price])

    if (!values.deliveryType) { return null }

    return <Grid item>
        <LocalizedStrict id="delivery-form-meeting-submit-button" attrs={{ loadingLabel: true }} vars={{ finalPrice }}>
            <FormikFloatingSubmitButton disabled={!isValid || values?.price <= 0} loadingLabel="Indlæser...">Næste (${finalPrice})</FormikFloatingSubmitButton>
        </LocalizedStrict>
    </Grid>
}

export default memo(SubmitButton)
